export function buildApiUrl(apiBaseUrl: string, path: string): string {
  const normalizedBase = apiBaseUrl.replace(/\/+$/, '');
  const apiRoot = normalizedBase.endsWith('/api') ? normalizedBase : `${normalizedBase}/api`;
  const normalizedPath = path.replace(/^\/+/, '');
  return `${apiRoot}/${normalizedPath}`;
}
